import { ChangeDetectionStrategy, Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { IOwnershipArea, IOwnershipUser } from '@fi-app/other-settings/transfer-ownership/fi-transfer-ownership';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { AppTextService } from '@fi-shared/app-text';
import { isDefined } from '@fi-shared/utils';

@Component({
    selector: 'fi-transfer-ownership-from-card',
    templateUrl: './fi-transfer-ownership-from-card.component.html',
    styleUrl: './fi-transfer-ownership-from-card.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-transfer-ownership-from-card' },
    standalone: false,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: FiTransferOwnershipFromCardComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: FiTransferOwnershipFromCardComponent,
        },
    ],
})
export class FiTransferOwnershipFromCardComponent extends ControlValueAccessorValidatorBase<IOwnershipUser> {
    @Input() fromAreas: IOwnershipArea[];
    @Input() isDisabled: boolean;

    doValidate(c: AbstractControl): ValidationErrors {
        return {
            required: !isDefined(this.ngModel),
        };
    }
}
